import "./assets/main.scss"
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMatomo from 'vue-matomo'
import { ConfigProgrammatic, ModalProgrammatic, Modal, Dialog, Toast, Input, Field, Tooltip, Sidebar,Menu, Loading, Icon, Pagination } from 'buefy'
import store from './store'
import AppLayout from '@/layouts/AppLayout'

import * as ChartistTooltips from 'chartist-plugin-tooltips';
import VueFeatherIconPack from "./components/VueFeatherIconPack.vue";

Vue.component("vue-feather-icon-pack", VueFeatherIconPack);


Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Input)
Vue.use(Field)
Vue.use(Tooltip)
Vue.use(Sidebar)
Vue.use(Menu)
Vue.use(Loading)
Vue.use(Icon)
Vue.use(Modal)
Vue.use(ModalProgrammatic)
Vue.use(Pagination)

ConfigProgrammatic.setOptions({
  defaultIconComponent: "vue-feather-icon-pack",
  defaultIconPack: "ft",
  customIconPacks: {
    ft: {
      sizes: {
        default: "1.5x",
        "is-small": "1x",
        "is-medium": "2x",
        "is-large": "3x"
      },
      iconPrefix: "",
      internalIcons: {
        check: "checkmark",
        information: "info",
        "check-circle": "checkmark-circle",
        alert: "alert-triangle",
        "alert-circle": "alert-circle",
        "arrow-up": "arrow-up",
        "chevron-right": "chevron-right",
        "chevron-left": "chevron-left",
        "chevron-down": "chevron-down",
        eye: "eye",
        "eye-off": "eye-off",
        "menu-down": "arrow-down",
        "menu-up": "arrow-up",
        plus: "plus",
      }
    }
  }
})

Vue.component('AppLayout', AppLayout)

Vue.use(VueMatomo, {
  // Configure your matomo server and site by providing
  host: 'https://feedletter.co/p',
  siteId: 10,

  // Changes the default .js and .php endpoint's filename
  // Default: 'matomo'
  trackerFileName: 'piwik',

  // Overrides the autogenerated tracker endpoint entirely
  // Default: undefined
  // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

  // Overrides the autogenerated tracker script path entirely
  // Default: undefined
  // trackerScriptUrl: 'https://example.com/whatever/script/path/you/have',

  // Enables automatically registering pageviews on the router
  router: router,

  // Enables link tracking on regular links. Note that this won't
  // work for routing links (ie. internal Vue router links)
  // Default: true
  enableLinkTracking: true,

  // Require consent before sending tracking information to matomo
  // Default: false
  requireConsent: false,

  // Whether to track the initial page view
  // Default: true
  trackInitialView: true,

  // Run Matomo without cookies
  // Default: false
  disableCookies: false,

  // Enable the heartbeat timer (https://developer.matomo.org/guides/tracking-javascript-guide#accurately-measure-the-time-spent-on-each-page)
  // Default: false
  enableHeartBeatTimer: true,

  // Set the heartbeat timer interval
  // Default: 15
  heartBeatTimerInterval: 5,
});

import { mapState } from 'vuex'
Vue.mixin({
  
  methods: {
    isEmptyOrSpaces: function(str) {
      return str === undefined || str === null || str.match(/^ *$/) !== null;
    },
    trackPageView: function (action) {
      try {
        window._paq.push(["setCustomUrl", "/" + action]);
        window._paq.push(["setDocumentTitle", action]);
        window._paq.push(["trackPageView"]);
      } catch (err) {}
    },
  },
  computed: {
    ...mapState([
      "user",
    ]),
    apiHost() {
      return process.env.API_HOST
    }
  },
})

Vue.use(require('vue-chartist'))
Vue.config.productionTip = false

new Vue({
  store,
  router,
  beforeCreate() { 
    this.$store.dispatch('initialiseStore').catch(err => {
      console.log("initialiseStore catch", err)
      this.$store.dispatch('logout').then(() => {
        console.log("logged out during initialiseStore", this.$store.getters.error)
        if(!this.$store.getters.error){
          this.$router.push("/")
        }
      })
    })
  },
  render: h => h(App)
}).$mount('#app')
